import {ActionTree} from 'vuex';
import {
	CREATE_ANSWER, LOAD_ANSWER, LOAD_ANSWERS, UPDATE_ANSWER
} from './actionTypes';
import {AppState} from '../app';
import {
	SET_ANSWERS,
	ADD_ANSWER,
	UPDATE_ANSWER_IN_CACHE,
	SET_CURRENT_ANSWER
} from './mutationTypes';
import { HANDLE_SERIOUS_ERROR } from '../app/actionTypes';
import { answersApi } from '@/features/bots/services/answers';
import { NLP_ENABLED } from '@/store/app/featureTypes';
import { CreateAnswerViewModel } from '@/features/bots/models/answers/createAnswerViewModel';
import { UpdateAnswerViewModel } from '@/features/bots/models/answers/updateAnswerViewModel';
import { AnswerViewModel } from '@/features/bots/models/answers/answerViewModel';
import { AnswersState } from '.';


export const actions: ActionTree<AnswersState, AppState> = {
	async [CREATE_ANSWER]({commit, rootState, dispatch}, request: CreateAnswerViewModel) {
		const currentWorkspace = (rootState as any).app.currentWorkspace;
		if (!currentWorkspace) {
			return dispatch(HANDLE_SERIOUS_ERROR, 'No workspace selected');
		}

		const createdAnswer = await answersApi.createAnswer(currentWorkspace.id, request);
		commit(ADD_ANSWER, createdAnswer);
		return createdAnswer;
	},

	async [UPDATE_ANSWER]({ commit, rootState, dispatch }, { answerId, request }: { answerId: string, request: UpdateAnswerViewModel }): Promise<AnswerViewModel> {
		const currentWorkspace = (rootState as any).app.currentWorkspace;
		if (!currentWorkspace) {
			return dispatch(HANDLE_SERIOUS_ERROR, 'No workspace selected');
		}

		const updatedAnswer = await answersApi.updateAnswer(currentWorkspace.id, answerId, request);
		commit(UPDATE_ANSWER_IN_CACHE, updatedAnswer);
		return updatedAnswer;
	},

	async [LOAD_ANSWERS]({commit, rootState, dispatch, state, getters}, doLoad: boolean) {
		const currentWorkspace = (rootState as any).app.currentWorkspace;
		if (!currentWorkspace) {
			return dispatch(HANDLE_SERIOUS_ERROR, 'No workspace selected');
		}

		if (getters.isWorkspaceFeatureEnabled(NLP_ENABLED) && (doLoad || !state.answers || state.answers.length === 0)) {
			try {
				const answers = await answersApi.getAnswers(currentWorkspace.id);
				if (answers) {
					commit(SET_ANSWERS, answers);
				}
			} catch (err: any) {
				throw new Error(`Error loading FAQs: ${err.message}`);
			}
		}
		return state.answers;
	},

	async [LOAD_ANSWER]({ commit, rootState, dispatch }, answerId: string): Promise<AnswerViewModel> {
		const currentWorkspace = (rootState as any).app.currentWorkspace;
		if (!currentWorkspace) {
			return dispatch(HANDLE_SERIOUS_ERROR, 'No workspace selected');
		}
		try {
			const answer = await answersApi.getAnswer(currentWorkspace.id, answerId);

			commit(SET_CURRENT_ANSWER, answer);

			return answer;
		} catch (err: any) {
			throw new Error(`Error loading FAQ: ${err.message}`);
		}
	},

};

